import {  LINK_PDF, PHOTO_LINK, SET_EMPRESA, GET_EMPRESAS, SET_FIRMA_CONTRATADA,SET_VIGENTES  } from "../actions/app.actions";

const initialState = {
    links: [],
    photo: '',
    empresa:'',
    empresas:[],
    firmaContratada:'',
    vigentes:true

}

const AppReducer = (state = initialState, action) => {

    switch (action.type) {
        case LINK_PDF: 
        return {
          ...state,
          links:[...state.links,action.payload]

        }
        case PHOTO_LINK: 
        return {
          ...state,
          photo: action.payload

        }

        case SET_EMPRESA:
          return {
            ...state,
            empresa:action.payload
          }

        case GET_EMPRESAS:
          return {
            ...state,
            empresas:action.payload
          }

        case SET_FIRMA_CONTRATADA:
          return {
            ...state,
            firmaContratada:action.payload
          }
        case SET_VIGENTES:
          return {
            ...state,
            vigentes:!state.vigentes
          }
    
        default:
            break;
    }
    return state

}

export default AppReducer